export const BOTTOM_NAV_BAR_ID = "bottom-navigation-bar";
export const BOTTOM_NAV_DRAWER_ID = "mobile-bottom-navigation-drawer";
